<template>
    <v-card>
        <v-toolbar flat color="#FFF">

            <v-btn :disabled="loading" icon @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title class="font-weight-medium pl-0">Назначить задание</v-toolbar-title>

            <v-spacer />

            <v-btn
                @click.prevent="resetFilters"
                color="error"
                :disabled="loading || checkedModel"
                small
            >
                Сбросить фильтр
            </v-btn>

            <v-btn small color="primary" @click="save" :loading="loading" class="ml-2">Назначить</v-btn>

        </v-toolbar>

        <v-divider />

        <v-container class="pl-6 pr-6" fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                    <v-col class="pb-0" cols="12" md="12">
                        <p class="font-weight-bold mb-0">Факультет*</p>
                        <v-autocomplete
                            label=""
                            :items="faculties"
                            v-model="facultiesSelected"
                            @click:clear="resetFaculties"
                            placeholder="Выберите факультет..."
                            @change="selectFaculties(facultiesSelected)"
                            :rules="[rules.requiredMultiple]"
                            outlined
                            height="40"
                            :small-chips="facultiesSelected.length > 0"
                            hide-details
                            item-value="id"
                            item-text="name"
                            multiple
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span v-if="likesAllFaculties">Выбраны все</span>
                                    <span v-else>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ facultiesSelected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>

                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleAllFaculties">
                                    <v-list-item-action>
                                        <v-icon :color="facultiesSelected.length > 0 ? 'primary' : ''">
                                            {{ iconFaculties }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>


                    <v-col cols="12" md="6">
                        <p class="font-weight-bold mb-0">Курс*</p>
                        <v-autocomplete
                            label=""
                            :rules="[rules.requiredMultiple]"
                            :items="listCourse"
                            v-model="courseSelected"
                            @click:clear="resetCourse"
                            :loading="loadingListCourse"
                            @change="selectCourse(courseSelected)"
                            :disabled="facultiesSelected.length === 0"
                            :placeholder="facultiesSelected.length === 0 ? 'Для разблокировки поля, нужно выбрать факультет' : 'Выберите курс'"
                            outlined
                            height="40"
                            :small-chips="facultiesSelected.length > 0"
                            class="addTask_combo"
                            hide-details
                            item-value="id"
                            item-text="name"
                            multiple
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span v-if="likesAllCourse">Выбраны все</span>
                                    <span v-else>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ courseSelected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>

                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleAllCourse">
                                    <v-list-item-action>
                                        <v-icon :color="courseSelected.length > 0 ? 'primary' : ''">
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>


                    <v-col cols="12" md="6">
                        <p class="font-weight-bold mb-0">Группа*</p>
                        <v-autocomplete
                            label=""
                            hide-details
                            :rules="[rules.requiredMultiple]"
                            :items="listGroup"
                            :loading="loadingListGroups"
                            height="40"
                            @change="selectGroup(groupSelected)"
                            :disabled="courseSelected.length === 0"
                            :placeholder="courseSelected.length === 0 ? 'Для разблокировки поля, нужно выбрать курс' : 'Выберите группу'"
                            :small-chips="courseSelected.length > 0"
                            item-value="id"
                            item-text="name"
                            v-model="groupSelected"
                            @click:clear="resetGroups"
                            outlined
                            class="addTask_combo"
                            multiple
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span v-if="likesAllGroup">Выбраны все</span>
                                    <span v-else>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ groupSelected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                            
                            <template v-if="listGroup.length > 0" v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleAllGroup">
                                    <v-list-item-action>
                                        <v-icon :color="groupSelected.length > 0 ? 'primary' : ''">
                                            {{ iconGroup }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <p class="font-weight-bold mb-0">ФИО обучающегося*</p>
                        <v-autocomplete
                            hide-details
                            ref="students"
                            :rules="[rules.requiredMultiple]"
                            label=""
                            height="40"
                            :disabled="groupSelected.length === 0"
                            :placeholder="groupSelected.length === 0 ? 'Для разблокировки поля, нужно выбрать группу' : 'Выберите студента(ов)'"
                            :items="listStudents"
                            item-value="id"
                            item-text="fio"
                            v-model="studentSelected"
                            outlined
                            class="addTask_combo"
                            multiple
                            clearable
                        >
                            <template v-if="listStudents.length > 0" v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleAllStudents">
                                    <v-list-item-action>
                                        <v-icon :color="studentSelected.length > 0 ? 'primary' : ''">
                                            {{ iconStudents }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>

                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span v-if="likesAllStudents">Выбраны все</span>
                                    <span v-else>{{ item.fio }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ studentSelected.length - 1 }} еще выбранных(й)
                                </span>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <p class="font-weight-bold mb-0">Тип теста*</p>
                        <v-autocomplete
                            ref="testTypes"
                            hide-details
                            :rules="[rules.required]"
                            height="40"
                            label=""
                            placeholder="Выберите тип теста"
                            :small-chips="testTypes.selected !== null"
                            :items="testTypes.list"
                            item-value="id"
                            item-text="name"
                            v-model="testTypes.selected"
                            @change="loadTasks"
                            :disabled="loadingPassTypes"
                            :loading="loadingPassTypes"
                            outlined
                            class="addTask_combo"
                        />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6">
                        <p class="font-weight-bold mb-0">Дисциплина</p>
                        <v-autocomplete
                            hide-details
                            label=""
                            :items="subjects.list"
                            height="40"
                            item-value="id"
                            item-text="name"
                            v-model="subjects.selected"
                            :small-chips="subjects.selected.length > 0"
                            :disabled="tasks === null"
                            :placeholder="subjects.placeholder"
                            :search-input.sync="subjects.input"
                            @change="setSubjectFilter"
                            outlined
                            class="addTask_combo"
                            multiple
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ subjects.selected.length - 1 }} еще выбранная(ые)
                                </span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col class="pb-0" cols="12" md="6">
                        <p class="font-weight-bold mb-0">Тема</p>
                        <v-autocomplete
                            hide-details
                            label=""
                            height="40"
                            :items="topics.list"
                            item-value="id"
                            item-text="name"
                            v-model="topics.selected"
                            :disabled="tasks === null"
                            :placeholder="topics.placeholder"
                            :search-input.sync="topics.input"
                            @change="setTopicFilter"
                            outlined
                            class="addTask_combo"
                            multiple
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1" class="grey--text text-caption">
                                    +{{ topics.selected.length - 1 }} еще выбранная(ые)
                                </span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col class="pb-0" cols="12" md="12">
                        <p class="font-weight-bold mb-0">Задания*</p>
                        <v-autocomplete
                            ref="tasks"
                            label=""
                            height="40"
                            :rules="[rules.requiredMultiple]"
                            :items="availableTasks.list"
                            item-value="id"
                            item-text="name"
                            v-model="availableTasks.selected"
                            :disabled="tasks === null"
                            :placeholder="availableTasks.placeholder"
                            :search-input.sync="availableTasks.input"
                            :persistent-hint="availableTasks.selected.length > 0 && testTypes.selected === 0"
                            :hint="testTypes.selected === 0 ? 'task' : ''"
                            return-object
                            outlined
                            class="addTask_combo"
                            multiple
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span v-if="likesAllTasks">Все</span>
                                    <span v-else>{{ item.name }}</span>
                                </v-chip>

                                <span v-if="index === 1 && !likesAllTasks" class="grey--text text-caption">
                                    +{{ availableTasks.selected.length - 1 }} еще выбранное(ых)
                                </span>
                            </template>

                            <template v-slot:prepend-item>
                                <v-list-item ripple @mousedown.prevent @click="toggleAllTasks">
                                    <v-list-item-action>
                                        <v-icon :color="availableTasks.selected.length > 0 ? 'primary' : ''">
                                            {{ iconTasks }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>

                            <template v-slot:message="{ message }">
                                <span v-if="message === 'task'">
                                    {{ showListTasks ? 'Чтобы установить по 10 вопросов в каждом задании, ' : 'В каждом задании будет по 10 вопросов. Чтобы изменить, ' }}
                                    <span
                                        class="cursor-pointer text-decoration-underline blue--text text--lighten-1"
                                        @click="clickShowTasks()"
                                    >
                                        нажмите сюда
                                    </span>
                                </span>
                                <span v-else>
                                    {{ message }}
                                </span>
                            </template>
                        </v-autocomplete>
                        <v-expand-transition>
                            <div v-if="showListTasks">
                                <v-row no-gutters>
                                    <v-col cols="12" md="6" v-if="checkBlockListTaks_1">
                                        <v-list-item
                                            v-for="(item, key) in chunkArray(availableTasks.selected, Math.ceil(availableTasks.selected.length / 2))[0]"
                                            :key="'d'+key"
                                            class="pl-0"
                                        >
                                            <v-list-item-avatar>
                                                <v-icon color="primary" dark>
                                                    mdi-clipboard-text
                                                </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title> {{ item.name }} </v-list-item-title>

                                            </v-list-item-content>

                                            <v-list-item-icon>
                                                <v-text-field
                                                    v-model="item.questionsCount"
                                                    :rules="[rules.minMax(item.questionsCount, 2, item.maxQuestionsCount)]"
                                                    class="w-80"
                                                    type="number"
                                                    :placeholder="`2-${item.maxQuestionsCount}`"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-list-item-icon>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="12" md="6" v-if="checkBlockListTaks_2">
                                        <v-list-item
                                            v-for="(item, key) in chunkArray(availableTasks.selected, Math.ceil(availableTasks.selected.length / 2))[1]"
                                            :key="'d'+key"
                                            class="pl-0"
                                        >
                                            <v-list-item-avatar>
                                                <v-icon color="primary" dark>
                                                    mdi-clipboard-text
                                                </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title> {{ item.name }} </v-list-item-title>

                                            </v-list-item-content>


                                            <v-list-item-icon>
                                                <v-text-field
                                                    v-model="item.questionsCount"
                                                    :rules="[rules.minMax(item.questionsCount, 2, item.maxQuestionsCount)]"
                                                    class="w-80"
                                                    type="number"
                                                    :placeholder="`2-${item.maxQuestionsCount}`"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-list-item-icon>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-expand-transition>
                    </v-col>

                    <v-col cols="6" md="3">
                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    hide-details
                                    placeholder="Срок сдачи от*"
                                    :rules="[rules.required]"
                                    clearable
                                    outlined
                                    :value="completeDates.begin | filterBirthday"
                                    class="mt-2"
                                    label=""
                                    prepend-icon="mdi-calendar"
                                />
                            </template>

                            <v-date-picker
                                v-model="completeDates.begin"
                                no-title
                                :first-day-of-week="1"
                                :min="completeDates.min"
                                :max="completeDates.end !== null ? completeDates.end : completeDates.max"
                                @input="menu = false"
                            />
                        </v-menu>
                    </v-col>


                    <v-col cols="6" md="3">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    hide-details
                                    outlined
                                    :rules="[rules.required]"
                                    clearable
                                    :value="completeDates.end | filterBirthday"
                                    class="mt-2"
                                    label=""
                                    placeholder="Срок сдачи до*"
                                    prepend-icon="mdi-calendar"
                                />
                            </template>

                            <v-date-picker
                                v-model="completeDates.end"
                                no-title
                                :first-day-of-week="1"
                                :min="completeDates.begin !== null ? completeDates.begin : completeDates.min"
                                :max="completeDates.max"
                                @input="menu2 = false"
                            />
                        </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                        <p class="font-weight-bold mb-0">Возможность повторного прохождения задания*</p>

                        <v-radio-group v-model="repeated" label="" row>
                            <v-radio label="Да" :value="true" />
                            <v-radio label="Нет" :value="false" />
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-form>

            <small class="text-subtitle-1">* указывает на обязательное поле</small>

            <ConfirmDialog ref="confirmDialog" @yes="assign" />
        </v-container>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmDialog from './ConfirmDialog.vue';
import { helpers } from '@/store/tests';
import lodash_chunk from 'lodash.chunk';

const AllId = 'all';

export default {
    name: 'AssignTaskDialog',
    components: { ConfirmDialog },
    props: {
        faculties: { type: Array, required: true }
    },
    data: () => ({
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        rules: {
            minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.',
            required: v => (!!v || v === 0) || 'Обязательно для заполнения!',
            requiredMultiple: v => v.length > 0 || 'Обязательно для заполнения.'
        },
        showListTasks: false,
        menu2: false,
        menu: false,
        valid: false,
        queryParamsFaculties: '',
        queryParamsCourse: '',
        paramsFaculties: [],
        paramsCourse: [],
        queryParamsStudents: '',
        loadingPassTypes: false,
        loadingListGroups: false,
        loadingListStudent: false,
        loadingListCourse: false,
        listCourse: [],
        listGroup: [],
        listStudents: [],
        facultiesSelected: [],
        courseSelected: [],
        groupSelected: [],
        studentSelected: [],
        passTypes: null,
        createStatuses: helpers.createStatuses,
        tasks: null,
        learningTasks: null,
        diagnosticsTasks: null,
        groupList: [],
        testTypes: {
            list: [],
            selected: null
        },
        studyCourse: {
            list: [],
            selected: [],
            input: ''
        },
        groups: {
            list: [],
            selected: [],
            input: ''
        },
        availableStudents: {
            list: [],
            selected: [],
            input: ''
        },
        subjects: {
            list: [],
            selected: [],
            placeholder: 'Для разблокировки поля, нужно выбрать тип теста',
            input: ''
        },
        topics: {
            list: [],
            selected: [],
            placeholder: 'Для разблокировки поля, нужно выбрать тип теста',
            input: ''
        },
        availableTasks: {
            list: [],
            selected: [],
            placeholder: 'Для разблокировки поля, нужно выбрать тип теста',
            input: ''
        },
        completeDates: {
            min: null,
            max: null,
            begin: null,
            end: null
        },
        repeated: false,
        loading: false
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        }),
        checkedModel() {
            let flag = this.facultiesSelected.length > 0 || this.courseSelected.length > 0 || this.groupSelected.length > 0 ||
                this.studentSelected.length > 0 || this.testTypes.selected !== null || this.subjects.selected.length > 0 ||
                this.topics.selected.length > 0 || this.availableTasks.selected.length > 0 || this.completeDates.begin || this.completeDates.end;

            if(flag) {
                return false;
            }

            return true
        },
        checkBlockListTaks_1() {
            if(!this.showListTasks) return false;
            if((this.availableTasks.selected && this.availableTasks.selected.length > 0) && (this.chunkArray(this.availableTasks.selected, Math.ceil(this.availableTasks.selected.length / 2)) && this.chunkArray(this.availableTasks.selected, Math.ceil(this.availableTasks.selected.length / 2))[0] ) ) {
                return true
            }


            return false;
        },
        checkBlockListTaks_2() {
            if(!this.showListTasks) return false;
            if((this.availableTasks.selected && this.availableTasks.selected.length > 0) && (this.chunkArray(this.availableTasks.selected, Math.ceil(this.availableTasks.selected.length / 2)) && this.chunkArray(this.availableTasks.selected, Math.ceil(this.availableTasks.selected.length / 2))[1] ) ) {
                return true
            }


            return false;
        },

        // Факультет
        iconFaculties() {
            if (this.likesAllFaculties) return 'mdi-close-box'
            if (this.likesSomeFaculties) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        likesAllFaculties() {
            return this.facultiesSelected.length === this.faculties.length
        },
        likesSomeFaculties() {
            return this.facultiesSelected.length > 0 && !this.likesAllFaculties
        },


        // Course
        likesAllCourse () {
            return this.courseSelected.length === this.listCourse.length
        },
        likesSomeCourse () {
            return this.courseSelected.length > 0 && !this.likesAllCourse
        },
        icon () {
            if (this.likesAllCourse) return 'mdi-close-box'
            if (this.likesSomeCourse) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },


        // Группы
        likesAllGroup () {
            return this.groupSelected.length === this.listGroup.length
        },
        likesSomeGroup () {
            return this.groupSelected.length > 0 && !this.likesAllGroup
        },
        iconGroup () {
            if (this.likesAllGroup) return 'mdi-close-box'
            if (this.likesSomeGroup) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },


        // Студенты
        likesAllStudents () {
            return this.studentSelected.length === this.listStudents.length
        },
        likesSomeStudents () {
            return this.studentSelected.length > 0 && !this.likesAllStudents
        },
        iconStudents () {
            if (this.likesAllStudents) return 'mdi-close-box'
            if (this.likesSomeStudents) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

        // Задания
        likesAllTasks () {
            return this.availableTasks.selected.length === this.availableTasks.list.length
        },
        likesSomeTasks () {
            return this.availableTasks.selected.length > 0 && !this.likesAllTasks
        },
        iconTasks () {
            if (this.likesAllTasks) return 'mdi-close-box'
            if (this.likesSomeTasks) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        }
    },
    methods: {
        clickShowTasks() {
            if(this.showListTasks) {
                for (let i = 0; i < this.availableTasks.list.length; i++) {
                    this.availableTasks.list[i].questionsCount = 10;
                }
            }

            this.showListTasks = !this.showListTasks;
        },
        resetFilters() {
            this.showListTasks = false;
            this.facultiesSelected = [];
            this.courseSelected = [];
            this.groupSelected = [];
            this.studentSelected = [];
            this.testTypes.selected = null;

            this.tasks = null;

            // Дисциплина
            this.subjects.selected = [];
            this.subjects.placeholder = 'Для разблокировки поля, нужно выбрать тип теста';
            this.subjects.list.forEach(x => {
                x.disabled = false;
            });

            // Тема
            this.topics.selected = [];
            this.topics.placeholder = 'Для разблокировки поля, нужно выбрать тип теста';
            this.topics.list.forEach(x => {
                x.disabled = false;
            });

            // Задания
            this.availableTasks.selected = [];
            this.availableTasks.placeholder = 'Для разблокировки поля, нужно выбрать тип теста';
            this.availableTasks.list.forEach(x => {
                x.questionsCount = 10;
                x.disabled = false;
            });

            this.completeDates.begin = null;
            this.completeDates.end = null;
            this.repeated = false;

            this.$refs.form.resetValidation()
        },
        // Факультет
        selectFaculties(arrayIds) {
            this.courseSelected = [];
            this.groupSelected = [];
            this.studentSelected = [];
            this.getCourse(arrayIds);
        },
        toggleAllFaculties() {
            this.$nextTick(() => {
                if (this.likesAllFaculties) {
                    this.facultiesSelected = []
                } else {
                    this.facultiesSelected = this.faculties.map((m) => m.id);
                }

                this.selectFaculties(this.facultiesSelected);
            })
        },
        resetFaculties() {
            this.courseSelected = [];
            this.groupSelected = [];
            this.studentSelected = [];
        },

        // Курс
        getCourse(arrayIds) {
            this.loadingListCourse = true;
            this.queryParamsFaculties = '';
            this.paramsFaculties = arrayIds;

            for (let i = 0; i < arrayIds.length; i++) {
                this.queryParamsFaculties += `${i === 0 ? '?' : '&'}`;
                this.queryParamsFaculties += `facultyIds=${arrayIds[i]}`
            }

            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyCourses${this.queryParamsFaculties}`)
                .then((response) => {
                    this.listCourse = response.data;
                    this.loadingListCourse = false;
                    // this.toggleAllCourse();
                });
        },
        toggleAllCourse() {
            this.$nextTick(() => {
                if (this.likesAllCourse) {
                    this.courseSelected = []
                } else {
                    this.courseSelected = this.listCourse.map((m) => m.id);
                }

                this.selectCourse(this.courseSelected);
            })
        },
        resetCourse() {
            this.groupSelected = [];
            this.studentSelected = [];
        },
        selectCourse(arrayIds) {
            this.groupSelected = [];
            this.studentSelected = [];
            this.getGroups(arrayIds);
        },


        // Группы
        getGroups(arrayIds) {
            this.loadingListGroups = true;
            this.queryParamsCourse = '';
            this.paramsCourse = arrayIds;

            for (let i = 0; i < arrayIds.length; i++) {
                this.queryParamsCourse += `&courseIds=${arrayIds[i]}`
            }

            this.$http.get(`${this.apiUrl}SprOrganizationUnit/GetStudyGroups${this.queryParamsFaculties}${this.queryParamsCourse}`)
                .then((response) => {
                    this.listGroup = response.data;
                    this.loadingListGroups = false;
                    // this.toggleAllGroup();
                });
        },
        resetGroups() {
            this.studentSelected = [];
        },
        toggleAllGroup() {
            this.$nextTick(() => {
                if (this.likesAllGroup) {
                    this.groupSelected = []
                } else {
                    this.groupSelected = this.listGroup.map((m) => m.id)
                }
                this.selectGroup(this.groupSelected);
            })
        },
        selectGroup(arrayIds) {
            this.studentSelected = [];
            if(arrayIds && arrayIds.length > 0) this.getStudents(arrayIds);
        },

        // студенты

        // студенты начало
        getStudents(arrayIds) {
            this.loadingListStudent = true;

            this.$http.post(`${this.apiUrl}Student/GetAll`, {
                filters: [{
                    fieldName: 'facultyId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: this.paramsFaculties
                },{
                    fieldName: 'studyCourseId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: this.paramsCourse
                },{
                    fieldName: 'groupId',
                    filterType: 9,
                    filterValueType: 1,
                    value1: '',
                    value2: '',
                    values: arrayIds
                }],
                sortOption: {
                    fieldName: 'fio',
                    sortType: 2
                },
                pageSize: 999999,
                currentPage: 0,
                useANDoperator: true,
                columns: []
            })
            .then((response) => {
                this.listStudents = response.data.data;
                this.loadingListStudent = false;
                // this.toggleAllStudents();
            });
        },
        toggleAllStudents() {
            this.$nextTick(() => {
                if (this.likesAllStudents) {
                    this.studentSelected = []
                } else {
                    this.studentSelected = this.listStudents.map((m) => m.id)
                }
            })
        },

        // Задания
        toggleAllTasks() {
            this.$nextTick(() => {
                if (this.likesAllTasks) {
                    this.showListTasks = false;
                    this.availableTasks.selected = [];
                } else {
                    this.availableTasks.selected = this.availableTasks.list;
                }
            })
        },




        changeGroup(lengthArray) {
            this.$nextTick(() => {
                if(lengthArray > 0) {
                    this.toggleAllStudents()
                } else {
                    this.availableStudents.selected = []
                    this.groups.selected = []
                }
            })
        },
        setCompleteDates() {
            const date = new Date();
            this.completeDates.min = date.toISOString().split("T")[0];

            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            this.completeDates.max = new Date(year + 1, month, day).toISOString().split("T")[0];
        },
        resetCompleteDates() {
            this.completeDates.begin = null;
            this.completeDates.end = null;
        },
        setTestTypes() {
            for (let i = 0; i < helpers.testTypes.length; i++) {
                this.testTypes.list.push({ id: i, name: helpers.testTypes[i] });
            }
        },
        loadPassTypes() {
            if (this.passTypes !== null) {
                return;
            }

            this.loadingPassTypes = true;

            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((response) => {
                    this.passTypes = response.data;
                    this.loadingPassTypes = false;
            });
        },
        getPassTypeIds(keyNames) {
            return this.passTypes.filter(x => keyNames.includes(x.keyName)).map(x => x.id);
        },
        loadTasks() {
            this.showListTasks = false;
            this.tasks = this.testTypes.selected === 0 ? this.learningTasks : this.diagnosticsTasks;

            if (this.tasks !== null) {
                this.resetSubjectFilter();
                return;
            }

            let params = {
                filters: [],
                sortOption: {
                    fieldName: 'title',
                    sortType: 2
                },
                pageSize: 1000,
                currentPage: 0,
                columns: [],
                createStatus: this.createStatuses.Published,
                passTypeIds: this.getPassTypeIds(['Control', 'Universal'])
            };

            let route = this.testTypes.selected === 0 ? 'TestTask' : 'DiaTest';

            this.$http.post(`${this.apiUrl}${route}/GetAll`, params)
                .then((response) => {
                    if (this.testTypes.selected === 0) {
                        this.learningTasks = response.data.data;
                        this.tasks = this.learningTasks;
                    } else {
                        this.diagnosticsTasks = response.data.data;
                        this.tasks = this.diagnosticsTasks;
                    }

                    this.resetSubjectFilter();
            });
        },
        resetStudyCourseFilter() {
            this.availableStudents.selected = [];
        },
        resetSubjectFilter() {
            this.subjects.list = [];

            this.subjects.list.push(...this.tasks
                .filter(x => x.studyDisciplineId !== null)
                    .map(y => {
                        return { id: y.studyDisciplineId, name: y.studyDisciplineName }
                    }));

            if (this.subjects.list.length > 0) {
                this.subjects.list.unshift({ id: AllId, name: 'Все' });
                this.subjects.placeholder = '';
            } else {
                this.subjects.placeholder = 'Нет подходящих заданий';
            }

            this.subjects.selected = [];

            this.setTopicFilterBySubjects();
        },
        setSubjectFilter() {
            this.subjects.input = '';

            let disabled = this.subjects.selected.includes(AllId)

            this.subjects.list.forEach(x => {
                if (x.id !== AllId) {
                    x.disabled = disabled;
                }
            });

            if (disabled) {
                this.subjects.selected = [ AllId ];
            }

            this.setTopicFilterBySubjects();
        },
        resetTopicFilter() {
            this.topics.list = [];

            this.topics.list.push(...this.tasks
                .filter(x => x.studyTopicId !== null)
                    .map(y => {
                        return { id: y.studyTopicId, name: y.studyTopicName }
                    }));

            if (this.topics.list.length > 0) {
                this.topics.list.unshift({ id: AllId, name: 'Все' });
                this.topics.placeholder = '';
            } else {
                this.topics.placeholder = 'Нет подходящих заданий';
            }

            this.topics.selected = [];

            this.setTaskFilterByTopics();
        },
        setTopicFilter() {
            this.topics.input = '';

            let disabled = this.topics.selected.includes(AllId)

            this.topics.list.forEach(x => {
                if (x.id !== AllId) {
                    x.disabled = disabled;
                }
            });

            if (disabled) {
                this.topics.selected = [ AllId ];
            }

            this.setTaskFilterByTopics();
        },
        setTopicFilterBySubjects() {
            if (this.subjects.selected.length > 0 && !this.subjects.selected.includes(AllId)) {

                this.topics.list = [{ id: AllId, name: 'Все' }];

                this.topics.list.push(...this.tasks
                    .filter(x => this.subjects.selected
                        .includes(x.studyDisciplineId))
                            .map(y => {
                                return { id: y.studyTopicId, name: y.studyTopicName }
                            }));


                this.setTopicFilter();

                this.setTaskFilterByTopics();
            } else {
                this.resetTopicFilter();
            }
        },
        resetTaskFilter() {
            this.availableTasks.list = [];

            this.availableTasks.list.push(...this.tasks
                .map(x => {
                    return { id: x.id, name: x.title, maxQuestionsCount: x.questionsCount, questionsCount: 10 }
                }));

            if (this.availableTasks.list.length > 0) {
                // this.availableTasks.list.unshift({ id: AllId, name: 'Все' });
                this.availableTasks.placeholder = '';
            } else {
                this.availableTasks.placeholder = 'Нет подходящих заданий';
            }

            this.availableTasks.selected = [];
        },
        setTaskFilter() {
            this.availableTasks.input = '';

            let disabled = this.availableTasks.selected.findIndex((f) => f.id === AllId) >= 0

            this.availableTasks.list.forEach(x => {
                x.questionsCount = 10;

                if (x.id !== AllId) {
                    x.disabled = disabled;
                }
            });

            if (disabled) {
                this.availableTasks.selected = this.availableTasks.list;
            }
        },
        setTaskFilterByTopics() {
            if (this.topics.selected.length > 0 && !this.topics.selected.includes(AllId)) {
                this.showListTasks = false;
                this.availableTasks.selected = [];

                this.availableTasks.list = this.tasks.filter(x => this.topics.selected.includes(x.studyTopicId) ).map(y => {
                    return { id: y.id, name: y.title, maxQuestionsCount: y.questionsCount, questionsCount: 10 }
                });

                // this.setTaskFilter();
            } else {
                this.resetTaskFilter();
            }
        },
        getParams() {
            let availableTasksSelected = [];

            if(this.availableTasks.selected.length > 0) {
                availableTasksSelected = this.availableTasks.selected.map((m) => ({ id: m.id, questionsCount: +m.questionsCount }))
            }
            return {
                testType: this.testTypes.selected,
                userIds: this.studentSelected,
                tests: availableTasksSelected,
                dateFrom: this.completeDates.begin,
                dateTo: this.completeDates.end,
                isRepeat: this.repeated
            };
        },
        save() {
            if(this.$refs.form.validate()) {
                this.loading = true;

                // console.log('save', this.getParams());

                this.$http.post(`${this.apiUrl}Student/CheckAssignedTasks`, this.getParams())
                    .then((response) => {
                        this.loading = false;

                        if (!response.data.success) {
                            this.$emit('snackbar', {
                                text: response.data.userMessage,
                                color: 'error',
                                timeout: -1,
                                show: true
                            });

                            return;
                        }

                        if (response.data.result.length > 0) {
                            this.$refs.confirmDialog.open(response.data.result);
                        } else {
                            this.assign();
                        }
                    });
            } else {
                // поля не заполнены
                this.$emit('snackbar', { text: 'Заполните корректно обязательные поля!', color: 'warning', timeout: 3000, show: true });
            }
        },
        assign() {
            this.loading = true;

            this.$http.post(`${this.apiUrl}Student/AssignTests`, this.getParams())
                .then((response) => {
                    this.loading = false;

                    if (!response.data.success) {
                        this.$emit('snackbar', {
                            text: response.data.userMessage,
                            color: 'error',
                            timeout: -1,
                            show: true
                        });

                        return;
                    }

                    this.$emit('success');

                    this.$emit('snackbar', {
                        text: 'Задания назначены',
                        color: 'success',
                        timeout: 5000,
                        show: true
                    });

                    this.close();
                }, () => {
                    this.loading = false;

                    this.$emit('snackbar', {
                        text: 'Произошла ошибка. Задания не были назначены.',
                        color: 'error',
                        timeout: -1,
                        show: true
                    });
                });
        },
        validateInput(input, value) {
            let message = value === null || value.length === 0 ? 'Обязательно для заполнения' : '';
            input.setCustomValidity(message);
        },
        close() {
            this.resetFilters();
            this.$emit('close');
        },
        chunkArray(array, chunk) {
            return lodash_chunk(array, chunk);
        }
    },
    created() {
        this.setTestTypes();
        this.setCompleteDates();
        this.loadPassTypes();
    }
}
</script>
